import type { FormProps } from 'antd/lib/form';
import Form from 'antd/lib/form';
import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';

export const StyledForm: StyledComponent<typeof Form, FormProps> = styled(Form)`
  &.ant-form-inline .ant-form-item:last-child {
    margin-right: 0;
  }

  .ant-form-item-required {
    position: relative;
    padding-left: 6px;

    &:before {
      position: absolute; // Fix label height for required elements
      left: 0;
    }
  }

  .ant-form-item-label > label .ant-form-item-tooltip {
    margin-inline-start: 4px;
  }
`;
